import React, { useState, forwardRef, useImperativeHandle } from 'react';
import '../../styles/projects/projects.css';
import { ReactComponent as TestTubeIcon } from '../../assets/svg/test-tube-svg.svg';


const WP2 = forwardRef((props, ref) => {
	const [isExpanded, setIsExpanded] = useState(false);

	const sectionRef = React.useRef(null);

	const toggleExpand = () => {
		setIsExpanded(!isExpanded);
	};

	useImperativeHandle(ref, () => ({
		expandSection() {
			if (sectionRef.current) {
				const yOffset = -100; 
				const y = sectionRef.current.getBoundingClientRect().top + window.pageYOffset + yOffset;
				window.scrollTo({ top: y, behavior: 'smooth' });
				setTimeout(() => {
					setIsExpanded(true);
				}, 370); 
			}
		},
	}));

	const leaders = [
		{ name: 'Johan Malmström (LU)', link: 'https://portal.research.lu.se/sv/persons/johan-malmstr%C3%B6m' },
		{ name: 'James Hadfield (AZ).', link: null },
		{ name: 'Haris Babacic (KI)', link: 'https://ki.se/personer/haris-babacic' },
		{ name: 'Elham Rekabdar (GU)', link: 'https://www.gu.se/en/about/find-staff/elhamrekabdar' },
		{ name: 'Dan Stetson', link: null },
		{ name: 'Paul Labrousse', link: null },
		{ name: 'Hugh Russell', link: null },
		{ name: 'David Shera', link: null },
		{ name: 'Henderson Fryer (AZ)', link: 'https://www.linkedin.com/in/henderson-fryer-303b598a' },
		{ name: 'Renata Blatnik (Bruker)', link: null },
		{ name: 'Kseniya Korchagina (Beckman)', link: null },
	];

	const [lead1, lead2, ...participants] = leaders;
	const renderPerson = (person, key) =>
		person.link ? (
			<a key={key} href={person.link} target="_blank" rel="noopener noreferrer">
				{person.name}
			</a>
		) : (
			<span key={key}>{person.name}</span>
		);


	return (
		<section className="WPinfo" ref={sectionRef}>
			<span className='wpinfo-icon'>
				<TestTubeIcon />
			</span>
			<span className="WPinfo-body">
				<h2>Work package 2: Tumor analysis advised plasma proteomics</h2>
				<p>
					<strong>Led by:</strong>{' '}
					{renderPerson(lead1, 'lead1')} <em>and</em> {renderPerson(lead2, 'lead2')}
				</p>

				{participants.length > 0 && (
					<p>
						<strong>Participants:</strong>{' '}
						{participants.map((p, i) => (
						<React.Fragment key={i}>
							{renderPerson(p, i)}
							{i < participants.length - 1 ? ', ' : ''}
						</React.Fragment>
						))}
						.
					</p>
				)}
				<div className={`expandable-content ${isExpanded ? 'expanded' : 'collapsed'}`}>
					WP2 focuses on developing advanced methods to analyze blood plasma with insights guided by tumor tissue characteristics. By 
					combining large reference sample cohorts with state-of-the-art sequencing and proteomics, the team is working to distinguish 
					tumor-derived signals from normal biological variation. This “tumor-informed” approach allows the detection of clinically relevant 
					protein patterns, estimation of tumor contribution in plasma, and identification of molecular subtypes that may support therapy 
					selection. The workflow will be refined through pilot studies and validated in ongoing patient cohorts, ensuring that the methods 
					are both robust and clinically meaningful. Ultimately, WP2 aims to deliver a new framework for plasma proteomics that can complement 
					tissue analysis and broaden the opportunities for minimally invasive cancer diagnostics. 
				</div>
				<button className="read-more-btn" onClick={toggleExpand}>
					{isExpanded ? 'Show Less' : 'Read More'}
				</button>
			</span>
		</section>
	);
});

export default WP2;
